import { ToastOptions } from "react-toastify";
import { showToast } from "@/providers";

const defaultOptions: Partial<ToastOptions> = {
  autoClose: 4000,
};

type Args = [string, Partial<ToastOptions>?];

export const toast = {
  success: (title: string, options: Partial<ToastOptions> = {}) =>
    showToast({ ...defaultOptions, ...options, type: "success", title }),
  error: (title: string, options: Partial<ToastOptions> = {}) =>
    showToast({ ...defaultOptions, ...options, type: "error", title }),
  info: (title: string, options: Partial<ToastOptions> = {}) =>
    showToast({ ...defaultOptions, ...options, type: "default", title }),
} satisfies Record<string, (...args: Args) => void>;
